import { render, staticRenderFns } from "./RcsCard.vue?vue&type=template&id=fc515a8a&scoped=true"
import script from "./RcsCard.vue?vue&type=script&lang=js"
export * from "./RcsCard.vue?vue&type=script&lang=js"
import style0 from "./RcsCard.vue?vue&type=style&index=0&id=fc515a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc515a8a",
  null
  
)

export default component.exports